<template>
	<v-dialog
		v-model="dialog"
		max-width="700px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">{{ dialogName }}</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="close()" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-form class="pa-2" ref="form" v-model="valid">
				<v-combobox
					v-model="category_value"
					ref="combobox"
					:items="categories"
					:rules="[rules.required]"
					:hint="categoryDialogHint"
					persistent-hint
					outlined
					:label="`${categoryDialogLabel}(必須)`"
					item-text="full_name"
					item-value="id"
					class="mt-4"
					dense
				/>
				<v-combobox
					v-model="task_value"
					ref="combobox"
					:items="tasks"
					:rules="[rules.required]"
					:hint="taskDialogHint"
					persistent-hint
					outlined
					:no-data-text="dialogNoDataText"
					:label="`${taskDialogLabel}(必須)`"
					item-text="requirement_type.name"
					item-value="id"
					class="mt-4"
					dense
				/>
			</v-form>
			<v-card-actions>
				<v-row no-gutters class="pb-2">
					<v-col cols="4" />
					<v-col cols="4">
						<v-row no-gutters justify="center">
							<v-btn color="secondary" @click="sendValue()" :disabled="!valid">
								<v-icon class="mr-2">mdi-plus</v-icon>
								追加する
							</v-btn>
						</v-row>
					</v-col>
					<v-col cols="4">
						<v-row no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="close()"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import rules from "../../helper/rules"

export default {
	props: {
		// カテゴリーのデータ
		categories: {
			type: Array,
			default: [],
		},
		// タスクのデータ
		tasks: {
			type: Array,
			default: [],
		},
		// タスク追加ダイアログのカテゴリーセレクトフォームのラベル名
		categoryDialogLabel: {
			type: String,
			default: "",
		},
		// タスク追加ダイアログのタスクセレクトフォームのラベル名
		taskDialogLabel: {
			type: String,
			default: "",
		},
		// タスク追加ダイアログのカテゴリーセレクトフォームのヒント
		categoryDialogHint: {
			type: String,
			default: "",
		},
		// タスク追加ダイアログのタスクセレクトフォームのヒント
		taskDialogHint: {
			type: String,
			default: "",
		},
		// タスク追加ダイアログの名前
		dialogName: {
			type: String,
			default: "",
		},
		// 部門ID
		departmentId: {
			type: String,
			default: "",
		},
		dialogNoDataText: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			dialog: false,
			rules: rules,
			id: this.$route.params["id"],
			errors: [],
			category_value: "",
			task_value: "",
			valid: false,
		}
	},

	methods: {
		open() {
			this.dialog = true
		},

		close() {
			this.errors = ""
			this.dialog = false
			this.$refs.form.reset()
		},

		sendValue() {
			this.$emit("send-value", this.category_value, this.task_value)
		},
	},
}
</script>
